import React, { useRef } from 'react';
import 'ol/ol.css';
import { fromLonLat } from 'ol/proj';
import { Map as OlMap } from 'ol';
import { defaults as defaultControls } from 'ol/control';
import { getView } from './OlExtension';
import { Box } from '@mui/material';
import { OverlayContainerNoGap } from './layers/OverlayContainerNoGap';

const BaseMapView = React.forwardRef((props, ref) => {
    const {
        initViewData,
        enableControls,
        enableInteraction,
        sx,
    } = props;

    const divRef = useRef(null);
    const mapObjRefs = useRef(null);
    const overlayContainerRef = useRef(null);

    React.useImperativeHandle(ref, () => ({
        GetOlMap,
        GetOverlayContainer
    }))

    React.useEffect(() => {
        if (divRef.current) {
            const map = new OlMap({
                target: divRef.current,
                controls: enableControls ? defaultControls({ zoom: true, rotate: false }).extend([]) : [],
                layers: [],
                view: initViewData ? getView(initViewData.zoom, fromLonLat(initViewData.center)) : getView(13, fromLonLat([127.01288, 37.296])),
            })

            if (!enableInteraction) {
                map.getInteractions().forEach(function (interaction) {
                    interaction.setActive(false);
                });
            }

            mapObjRefs.current = {
                map,
            };

            return () => map.setTarget(undefined);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [divRef]);

    const GetOlMap = () => {
        return mapObjRefs.current?.map
    }

    const GetOverlayContainer = () => {
        return overlayContainerRef.current
    }
    return (
        <Box sx={{ height: '100%', width: '100%', display: 'grid', ...sx }}>
            <div ref={divRef}/>
            <OverlayContainerNoGap ref={overlayContainerRef} map={mapObjRefs.current?.map}/>
        </Box>
    );
});

export default BaseMapView;